import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import ChatPage from './pages/ChatPage';
import AdminPage from './pages/AdminPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import StudioPage from './pages/StudioPage';

function AppRouter() {
  const { user, loading } = useAuth();
  const [view, setView] = useState('chat'); // chat | admin | admin:supervision | studio | password

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: 'var(--bg)',
        fontFamily: "'Plus Jakarta Sans', sans-serif", color: 'var(--text-3)', fontSize: 14,
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10, margin: '0 auto 16px',
            background: 'var(--accent-gradient)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 14, fontWeight: 800, color: 'var(--on-accent)', letterSpacing: 2,
          }}>EAS</div>
          Verificando sesión...
        </div>
      </div>
    );
  }

  if (!user) return <LoginPage />;

  // Primer ingreso o contraseña restablecida: no se entra al portal sin cambiarla
  if (user.must_change_password) return <ChangePasswordPage />;

  if (view === 'password') {
    return <ChangePasswordPage onCancel={() => setView('chat')} onDone={() => setView('chat')} />;
  }
  // El backend igual rechaza /api/admin a quien no sea admin; esto solo evita mostrar la vista
  if (view.startsWith('admin') && user.role === 'admin') {
    return <AdminPage onBack={() => setView('chat')} initialTab={view.split(':')[1]} onOpenStudio={() => setView('studio')} />;
  }
  if (view === 'studio' && user.role === 'admin') {
    return <StudioPage onBack={() => setView('chat')} onOpenTable={() => setView('admin:supervision')} />;
  }

  return (
    <ChatPage
      onOpenAdmin={user.role === 'admin' ? () => setView('admin') : null}
      onOpenStudio={user.role === 'admin' ? () => setView('studio') : null}
      onChangePassword={() => setView('password')}
    />
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
